import React from 'react';
import PropTypes from 'prop-types';


import OverlayLoading from '../common/overlayLoading/OverlayLoading';
import NavBar from '../navBar/NavBar';

import Footer from '../footer/Footer';
import LandingSection from './landing/Landing';
import ProjectDetailsSection from './projectDetails/ProjectDetails';
import ScrollToTopOnMount from '../ScrollToTop';
import { fetchProjects, fetchTRLInfo } from '../helpers/DataProvider';

import TRLSection from './trl/TRLSection';

import { trackPage } from '../helpers/AnalyticsManager';

class Project extends React.Component {
  constructor(props) {
    super(props);
    let projName;

    if (props.location.state) {
      projName = props.location.state.project.title;

      this.state = {
        project: props.location.state.project,
        isLoading: false,
      };
    } else {
      projName = props.match.params.projectName;
      this.state = {
        projectTitle: projName,
        isLoading: true,
      };
    }
    trackPage(`Project: ${projName}`);
  }


  componentDidMount() {
    const { projectTitle, project } = this.state;
    if (!project) {
      fetchProjects((projects) => {
        const queryProject = projects.find(proj => (
          proj.title.toUpperCase() === projectTitle.toUpperCase()
        ));
        if (queryProject) {
          this.setState({
            project: queryProject,
            isLoading: false,
          });
        } else {
          this.setState({
            // notFound: true, // TODO: Handle not found state
          });
        }
        fetchTRLInfo((trlSheet) => {
          const trlInfo = trlSheet.find(trl => (trl.trl === queryProject.trl));
          if (trlInfo) {
            this.setState({
              project: queryProject,
              isLoading: false,
              trlInfo,
            });
          }
        });
      });
    } else {
      fetchTRLInfo((trlSheet) => {
        const trlInfo = trlSheet.find(trl => (trl.trl === project.trl));
        if (trlInfo) {
          this.setState({
            project,
            isLoading: false,
            trlInfo,

          });
        }
      });
    }
  }

  render() {
    const { project, isLoading, trlInfo } = this.state;

    return (
      <div>
        <OverlayLoading loading={isLoading} />
        <ScrollToTopOnMount />
        <NavBar darkMode />
        { project && (
          <LandingSection
            title={project.title}
            shortPhrase={project.shortphrase}
            shortDesc={project.shortdescription}
            video={project.video}
            image={project.image}
          />
        )}
        {trlInfo && (<TRLSection image={trlInfo.image} />)}
        { project && trlInfo && (
          <ProjectDetailsSection
            authors={project.authors}
            images={project.images}
            description={project.description}
            benefits={project.benefits}
            applications={project.applications}
            ipstatus={project.ipstatus}
            trl={trlInfo.description}
            projectid={project.projectid}
            factsheet={project.factsheet}
          />
        )}
        <Footer target="industry" language="portuguese" />
      </div>
    );
  }
}

Project.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      project: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }).isRequired,
    }),
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      projectName: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Project;
